import { ConnectedPosition } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import * as R from 'ramda';

import { FeatureGuidePosition, FeatureGuidePositionData } from './feature-guide-position';

@Injectable()
export class FeatureGuidePositionService {

  calculatePosition(positionData: FeatureGuidePositionData): ConnectedPosition[] {
    const position = R.prop('position', positionData);

    return R.cond([
      [R.equals(FeatureGuidePosition.LEFT_TOP), R.always(this.leftTop(positionData))],
      [R.equals(FeatureGuidePosition.RIGHT_TOP), R.always(this.rightTop(positionData))],
      [R.equals(FeatureGuidePosition.BOTTOM_LEFT), R.always(this.bottomLeft(positionData))],
      [R.equals(FeatureGuidePosition.BOTTOM_RIGHT), R.always(this.bottomRight(positionData))],
      [R.equals(FeatureGuidePosition.TOP_LEFT), R.always(this.topLeft(positionData))]
    ])(position);
  }

  private leftTop(positionData: FeatureGuidePositionData) {
    return [{
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top',
      offsetX: positionData.hostSize.width * (-1)
    } as ConnectedPosition
    ];
  }

  private rightTop(positionData: FeatureGuidePositionData) {
    return [{
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
      offsetX: positionData.hostSize.width
    } as ConnectedPosition
    ];
  }

  private bottomLeft(positionData: FeatureGuidePositionData) {
    return [{
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
      offsetY: positionData.hostSize.height
    } as ConnectedPosition
    ];
  }

  private bottomRight(positionData: FeatureGuidePositionData) {
    return [{
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top',
      offsetY: positionData.hostSize.height
    } as ConnectedPosition
    ];
  }

  private topLeft(positionData: FeatureGuidePositionData) {
    return [{
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
      offsetY: positionData.tooltipSize.height * (-1)
    } as ConnectedPosition
    ];
  }
}
